import React from 'react';

import {
  ModelConfigEditable,
  ModelConfigValue,
  ModerationModel,
  MultipleThresholds,
  SingleThreshold
} from '../../moderationFiltersTypes';
import { Tag } from '../../../../../../moderation-v2/comments-and-posts/state/types';
import RangeSlider from '../../../../../../common/inputs/range-slider';
import { ModerationFiltersMultiThresholds } from '../ModerartionFiltersMultiTresholds';
import {
  DEFAULT_SINGLE_THRESHOLD,
  INAPPROPRIATE_USERNAME_MODEL,
  MEDIUM_NUM_THRESHOLD,
  MEDIUM_PERCENTAGE_THRESHOLD,
  SPAM_SIMILARITY_DEFAULT_THRESHOLDS
} from '../../moderationFiltersConstants';

import styles from './ModerationFiltersThresholds.module.scss';

interface ModerationFiltersThresholdsProps {
  isSuperAdmin: boolean;
  currentModel: string;
  config: ModelConfigEditable;
  onConfigChange: (tag: string, value: ModelConfigValue) => void;
}

export function ModerationFiltersThresholds(props: ModerationFiltersThresholdsProps) {
  const { isSuperAdmin, config, currentModel, onConfigChange } = props;
  const { label, value, selected } = config;

  const isSingleThresholdFlag = isSingleThreshold(currentModel);
  const isSpamSimilarity = currentModel === Tag.OPENWEB_SPAM_SIMILARITY;

  const reset = () => {
    const newThresholds = mediumByTagMap[currentModel] || MEDIUM_PERCENTAGE_THRESHOLD;

    onConfigChange(currentModel, { ...newThresholds });
  };

  return (
    <div className={styles.container}>
      <div className={styles.title}>{label}</div>
      <div className={styles.description}>
        {isSingleThresholdFlag || isSpamSimilarity ? (
          'Define threshold level'
        ) : (
          <>
            Define the sensitivity level of this filter. (<b>Low</b> - less strict, <b>High</b> - very strict)
          </>
        )}
      </div>
      {isSingleThresholdFlag && (
        <RangeSlider
          value={getSingleThresholdValue(value)}
          onChange={value => {
            const newConfig: SingleThreshold = {
              type: 'single',
              threshold: value
            };

            onConfigChange(currentModel, newConfig);
          }}
          disabled={!selected}
          isValuePercentage={true}
        />
      )}
      {!isSingleThresholdFlag && isSpamSimilarity && (
        <RangeSlider
          value={(value as MultipleThresholds).reject}
          onChange={value => {
            const newConfig: MultipleThresholds = {
              type: 'multiple',
              requireApproval: 100,
              publishAndModerate: 100,
              reject: value
            };

            onConfigChange(currentModel, newConfig);
          }}
          disabled={!selected}
          isValuePercentage={true}
        />
      )}
      {!isSingleThresholdFlag && !isSpamSimilarity && (
        <ModerationFiltersMultiThresholds
          value={value as MultipleThresholds}
          disabled={!selected}
          currentModel={currentModel}
          onConfigChange={onConfigChange}
          isSuperAdmin={isSuperAdmin}
        />
      )}
      <span className={styles.resetButton} onClick={reset}>
        Reset to default
      </span>
    </div>
  );
}

function isSingleThreshold(model: string): boolean {
  return [Tag.SUSPECTED_BOT, INAPPROPRIATE_USERNAME_MODEL].toString().includes(model);
}

function getSingleThresholdValue(value: ModelConfigValue): number {
  return value && value.type === 'single' ? value.threshold : 95;
}

const mediumByTagMap = {
  [Tag.SUSPECTED_BOT]: DEFAULT_SINGLE_THRESHOLD,
  [ModerationModel.Incivility]: MEDIUM_NUM_THRESHOLD,
  [Tag.OPENWEB_SPAM_SIMILARITY]: SPAM_SIMILARITY_DEFAULT_THRESHOLDS
};
